import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { useAuthContext } from "../../contexts/AuthContext";
import "./styles.css";

/** Login exclusivo da fachada app.ellobeleza.com.
 * Reutiliza a autenticação existente do Gestor. Nenhuma licença é concedida no frontend.
 */
export default function BelezaLogin() {
  const navigate = useNavigate();
  const { login } = useAuthContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const old = document.title;
    document.title = "ÉLLO Professional | Gestão";
    return () => { document.title = old; };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      const response = await api.post("/api/Auth/login", {
        email: email.trim().toLowerCase(), password,
      });
      const result = response.data?.data;
      if (!response.data?.success || !result?.token) {
        throw new Error(response.data?.message || "Não foi possível autenticar.");
      }
      const { token, user, permissions, entidadeId, unidadeId } = result;
      const context = { entidadeId: entidadeId || user?.entidadeId, unidadeId: unidadeId || user?.unidadeId };
      if (context.entidadeId) {
        localStorage.setItem("Entidade", String(context.entidadeId));
        localStorage.setItem("entidadeId", String(context.entidadeId));
        localStorage.setItem("selectedEntidade", String(context.entidadeId));
      }
      if (context.unidadeId) {
        localStorage.setItem("Unidade", String(context.unidadeId));
        localStorage.setItem("unidadeId", String(context.unidadeId));
        localStorage.setItem("selectedUnidade", String(context.unidadeId));
      }
      login(token, user, permissions || []);
      if (user?.primeiroAcesso) {
        sessionStorage.setItem("senhaAtual", password);
        navigate("/Security/alterar-senha-primeiro-acesso", {
          replace: true, state: { email: user?.email || email, senhaAtual: password },
        });
      } else {
        navigate("/loginfilter", { replace: true });
      }
    } catch (err) {
      const server = err?.response?.data;
      setError(server?.message || server?.errors?.[0] || err.message || "Não foi possível entrar. Verifique as credenciais.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ello-management-login">
      <section className="ello-management-hero" aria-label="ÉLLO Professional">
        <img className="ello-management-hero-logo" src="/pwa-beleza-logo-escuro.jpg" alt="ÉLLO Professional" />
        <div className="ello-management-hero-copy">
          <span className="ello-management-eyebrow">GESTÃO PARA BELEZA E ESTÉTICA</span>
          <h1>O seu salão. Uma gestão à altura.</h1>
          <p>Agenda, equipa, serviços, caixa e resultados organizados num único sistema.</p>
        </div>
        <span className="ello-management-hero-footnote">ÉLLO Professional · Solução de gestão</span>
      </section>
      <main className="ello-management-login-column">
        <div className="ello-management-card">
          <img className="ello-management-mobile-logo" src="/pwa-beleza-logo-claro.jpg" alt="ÉLLO Professional" />
          <span className="ello-management-eyebrow">ACESSO AO SISTEMA</span>
          <h2>Bem-vindo de volta</h2>
          <p className="ello-management-subheading">Entre com o mesmo utilizador e palavra-passe do Gestor.</p>
          {error && <div className="ello-management-error" role="alert">{error}</div>}
          <form onSubmit={handleSubmit}>
            <label htmlFor="ello-login-email">E-mail</label>
            <input id="ello-login-email" type="email" required autoComplete="username"
              placeholder="nome@exemplo.com" value={email} onChange={event => setEmail(event.target.value)} />
            <label htmlFor="ello-login-password">Palavra-passe</label>
            <div className="ello-management-password">
              <input id="ello-login-password" type={showPassword ? "text" : "password"} required
                autoComplete="current-password" value={password}
                placeholder="A sua palavra-passe" onChange={event => setPassword(event.target.value)} />
              <button type="button" aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                onClick={() => setShowPassword(value => !value)}>{showPassword ? "Ocultar" : "Mostrar"}</button>
            </div>
            <button type="submit" className="ello-management-submit" disabled={loading}>{loading ? "A entrar…" : "Entrar na gestão"}</button>
          </form>
          <button type="button" className="ello-management-recovery"
            onClick={() => navigate("/Security/recuperar-senha")}>Esqueceu a palavra-passe?</button>
          <p className="ello-management-footnote">Acesso sujeito às licenças, unidades e permissões da sua conta.</p>
        </div>
      </main>
    </div>
  );
}
